import keyMirror from 'src/common/utils/keyMirror';

export default keyMirror(
  'idle',
  'loaded',
  'playing',
  'preroll',
  'paused',
  'stopped',
  'connecting',
  'failed',
  'popout',
);
